import { jsx as m } from "react/jsx-runtime";
import { c as e } from "react/compiler-runtime";
import { RadioGroup as s } from "@mui/material";
import { forwardRef as f } from "react";
const R = f((i, t) => {
  const o = e(5);
  let r;
  o[0] !== i ? ({
    ...r
  } = i, o[0] = i, o[1] = r) : r = o[1];
  let p;
  return o[2] !== r || o[3] !== t ? (p = /* @__PURE__ */ m(s, { ref: t, ...r }), o[2] = r, o[3] = t, o[4] = p) : p = o[4], p;
});
export {
  R as RadioGroup
};
